/**
 * Convert a stored gig date string to the user's local YYYY-MM-DD.
 *
 * Backend stores gig dates inconsistently:
 *   - Plain local date:   "2026-04-24"
 *   - UTC ISO with time:  "2026-04-23T23:00:00.000Z"   (= Apr 24 00:00 BST)
 *
 * A naive [:10] slice on the second form gives "2026-04-23" — one day early
 * for BST users. This helper returns the correct local date in both cases.
 *
 * @param {string|null|undefined} isoString
 * @returns {string|null}  "YYYY-MM-DD" in local timezone, or null.
 */
export const gigLocalDate = (isoString) => {
  if (!isoString) return null;
  if (!isoString.includes('T')) return isoString.slice(0, 10);
  return new Date(isoString).toLocaleDateString('en-CA');
};

// UK tax year containing `dateString`, as the short "2026/27" form.
//
// The UK tax year runs 6 April -> 5 April the following year. Note JS months
// are 0-indexed here, so April is 3 — which is why this does not look like its
// backend twin even though it is the same rule.
//
// Backend twin: `_uk_tax_year` in backend/server.py, which returns the LONG
// "2026/2027" form (RevenueOverview shortens it for display). Keep the two in
// step: the boundary is the (month, day) pair, never two separate tests.
export const getTaxYearLabel = (dateString) => {
  if (!dateString) return null;
  const d = new Date(dateString);
  if (isNaN(d)) return null;
  const month = d.getMonth();    // 0-11; April = 3
  const day = d.getDate();
  const inNewTaxYear = month > 3 || (month === 3 && day >= 6);
  const startYear = inNewTaxYear ? d.getFullYear() : d.getFullYear() - 1;
  return `${startYear}/${String(startYear + 1).slice(-2)}`;
};
